import { render, staticRenderFns } from "./titulares-suministro.vue?vue&type=template&id=8e920252&"
import script from "./titulares-suministro.vue?vue&type=script&lang=js&"
export * from "./titulares-suministro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports